import { useQuery } from '@tanstack/react-query';
import _ from 'lodash';
import { SyncingWithScorabilityLogsRef } from '../../utils/refs';
import { query, where, orderBy, limit, getDocs } from 'firebase/firestore';

const fetchSendScoresToScorabilityErrors = async (slug) => {
  const collectionRef = SyncingWithScorabilityLogsRef();

  // Calculate the timestamp for 24 hours ago
  const twentyFourHoursAgo = new Date(Date.now() - 24 * 60 * 60 * 1000);

  // Create a query that:
  // - Filters for documents that are less than 24 hours old
  // - Filters for documents where 'resolved' is true
  // - Orders documents by 'createdOn' in descending order
  // - Limits the results to 50 documents
  // - Returns only 'createdOn' and 'resolved' fields
  const q = query(collectionRef, where('createdOn', '>=', twentyFourHoursAgo), where('resolved', '==', false), orderBy('createdOn', 'desc'), limit(50));

  // Execute the query
  const querySnapshot = await getDocs(q);

  // Optionally, count how many documents were returned
  let count = querySnapshot.size;

  return count;
};

export default function useSendScoresToScorabilityErrors() {
  return useQuery({
    queryKey: ['SendScoresToScorabilityErrors'],
    queryFn: async () => fetchSendScoresToScorabilityErrors(),
    onError: (err) => {
      console.error('error fetching syncing errors with Scorability: ', err);
    }
  });
}
